import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ResizedDirective } from '../directives/resized.directive';
import { AlertBannerComponent } from './gains-alert-banner/alert-banner.component';
import { GainsBreadcrumbComponent } from './gains-breadcrumb/gains-breadcrumb.component';
import { GainsCollapseComponent } from './gains-collapse/gains-collapse.component';
import { GainsDatePickerComponent } from './gains-date-picker/gains-date-picker.component';
import { GainsActionCellComponent } from './gains-grid/gains-action-cell-component/gains-action-cell.component';
import { GainsColoredTextCellComponent } from './gains-grid/gains-colored-text-cell-component/gains-colored-text-cell.component';
import { GainsGridComponent } from './gains-grid/gains-grid.component';
import { GainsInputActionCellComponent } from './gains-grid/gains-input-action-cell-component/gains-input-action-cell.component';
import { GainsToggleComponent } from './gains-toggle/gains-toggle.component';
import { GainsInputTitleComponent } from './gains-input-title/gains-input-title.component';
import { GainsInputComponent } from './gains-input/gains-input.component';
import { GainsSelectComponent } from './gains-select/gains-select.component';
import { GainsSpinnerComponent } from './gains-spinner/gains-spinner.component';
import { GainsTabComponent } from './gains-tab/gains-tab.component';
import { GainsTabsetComponent } from './gains-tabset/gains-tabset.component';
import { GainsTilesComponent } from './gains-tiles/gains-tiles.component';
import { GainsTimePickerComponent } from './gains-time-picker/gains-time-picker.component';
import { GainsTitleComponent } from './gains-title/gains-title.component';
import { SidebarComponent } from './sidenav/sidenav.component';
import { GainsSuccessModalComponent } from './gains-success-modal/gains-success-modal.component';
import { GainsJsonViewerComponent } from './gains-json-viewer/gains-json-viewer.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { GapRequiresDirective } from '../permissions/gap-requires.directive';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { GainsSwitchComponent } from './gains-switch/gains-switch.component';
import { GainsCheckboxComponent } from './gains-checkbox/gains-checkbox.component';
import { GainsRadioGroupComponent } from './gains-radio-group/gains-radio-group.component';
import { GainsTagComponent } from './gains-tag/gains-tag.component';
import { GainsBannerComponent } from './gains-banner/gains-banner.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzAlertModule } from 'ng-zorro-antd/alert';
@NgModule({
  declarations: [
    GainsSwitchComponent,
    GainsCheckboxComponent,
    GainsRadioGroupComponent,
    GainsTagComponent,
    GainsBannerComponent,
    SidebarComponent,
    GainsGridComponent,
    GainsInputComponent,
    GainsTitleComponent,
    GainsInputTitleComponent,
    GainsActionCellComponent,
    GainsTabsetComponent,
    GainsTabComponent,
    GainsBreadcrumbComponent,
    GainsTilesComponent,
    AlertBannerComponent,
    GainsDatePickerComponent,
    GainsTimePickerComponent,
    GainsSelectComponent,
    ResizedDirective,
    GainsCollapseComponent,
    GainsInputActionCellComponent,
    GainsColoredTextCellComponent,
    GainsToggleComponent,
    GainsSpinnerComponent,
    GainsSuccessModalComponent,
    GainsJsonViewerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NzInputModule,
    AngularSvgIconModule.forRoot(),
    NzCheckboxModule,
    NzRadioModule,
    NzTagModule,
    NzAlertModule,
    NzDividerModule,
    NzLayoutModule,
    NzImageModule,
    NzMenuModule,
    NzToolTipModule,
    NzSelectModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridAngular,
    NzDatePickerModule,
    NzTimePickerModule,
    NzModalModule,
    NzDropDownModule,
    NzTabsModule,
    NzSwitchModule,
    NzBreadCrumbModule,
    NzCollapseModule,
    NzBadgeModule,
    NzSpinModule,
    NzButtonModule,
    GapRequiresDirective
  ],
  exports: [
    AngularSvgIconModule,
    GainsSwitchComponent,
    GainsCheckboxComponent,
    GainsRadioGroupComponent,
    GainsTagComponent,
    GainsBannerComponent,
    SidebarComponent,
    RouterModule,
    GainsGridComponent,
    GainsInputComponent,
    GainsTitleComponent,
    GainsInputTitleComponent,
    GainsActionCellComponent,
    GainsTabComponent,
    GainsTabsetComponent,
    GainsBreadcrumbComponent,
    GainsTilesComponent,
    AlertBannerComponent,
    GainsDatePickerComponent,
    GainsTimePickerComponent,
    GainsSelectComponent,
    ResizedDirective,
    GainsCollapseComponent,
    GainsColoredTextCellComponent,
    GainsToggleComponent,
    GainsSpinnerComponent,
    GainsSuccessModalComponent,
    GainsJsonViewerComponent,
    GapRequiresDirective,
    NzToolTipModule
  ]
})
export class GainsSharedModule {}
